import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Toolbar as StyleToolbar } from 'styles/toolbar'
import { emotionCSSToStyle } from 'styles/utils'

export const Toolbar = StyleToolbar

export const selectStyle = emotionCSSToStyle(css`
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 340px;
`)

export const Pagination = styled.nav`
  display: flex;
  justify-content: flex-end;
  flex: 1;
`
